import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getReplacedString } from '../../../helpers/getReplacedString';

const filterCb =
  ({ key, searchValue }) =>
  (item) => {
    const itemValue = typeof key === 'function' ? key(item) : item[key];
    const value = getReplacedString(itemValue);
    const search = getReplacedString(searchValue);
    return value.includes(search);
  };

const createSelector = (mode) => (state) =>
  state.housingStockStore.searchFieldValue[mode];

const useFilteredBySearchData = ({ data, key, mode }) => {
  const value = useSelector(createSelector(mode));

  const [loading, setLoading] = useState(false);
  const [filteredData, setFilteredData] = useState(() => {
    const trimVal = value?.trim();
    const items = data || [];
    return trimVal
      ? items.filter(filterCb({ key, searchValue: trimVal }))
      : items;
  });

  useEffect(() => {
    const trimVal = value?.trim();
    const items = data || [];
    let timeoutId;

    if (trimVal) {
      setLoading(true);
      timeoutId = setTimeout(() => {
        const newData = items.filter(filterCb({ key, searchValue: trimVal }));
        setFilteredData(newData);
        setLoading(false);
      }, 700);
    } else {
      setLoading(false);
      setFilteredData(items);
    }

    return () => clearTimeout(timeoutId);
  }, [value, data, key]);

  return [loading, filteredData];
};

export default useFilteredBySearchData;
